import { FC, useEffect } from 'react';
import { useSetAtom } from 'jotai';

import { titleSearchQueryAtomJ } from '../../../services/state/PeopleByCompanyStateJ';
import { SearchInput } from '../../../CoreComponents/base/SearchInput';

export const SearchByTitle: FC = () => {
  const setTitleQuery = useSetAtom(titleSearchQueryAtomJ);

  useEffect(() => {
    return () => {
      setTitleQuery('');
    };
  }, [setTitleQuery]);

  return <SearchInput style={{ width: '14rem' }} onChange={setTitleQuery} placeholder='Search by title' />;
};
